import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "d-flex align-items-stretch w-100",
  style: {"min-height":"64px"}
}
const _hoisted_2 = { class: "d-flex align-items-center flex-shrink-0" }
const _hoisted_3 = {
  key: 0,
  class: "ms-3 title-font fs-2 fw-bold"
}
const _hoisted_4 = {
  class: "d-flex align-items-stretch flex-grow-1 mx-4",
  style: {"min-width":"0"}
}
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center flex-shrink-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn_back = _resolveComponent("btn-back")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_btn_back, {
        onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
      }),
      (_ctx.text)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "center")
    ]),
    (_ctx.$slots.right)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "right")
        ]))
      : _createCommentVNode("", true)
  ]))
}